import { EyeIcon } from 'lucide-react';
import { useState } from 'react';

import MediaViewer from '@/components/features/media/MediaViewer';
import { Button } from '@/components/ui/button';

import { useAttachmentFile } from './useAttachmentFile';

interface AttachmentPreviewButtonProps {
  id: string;
  name: string;
  className?: string;
}

/**
 * Button that opens the media viewer for a stored attachment. Use when a file
 * needs a preview affordance without the full attachment card.
 */
export function AttachmentPreviewButton(props: AttachmentPreviewButtonProps) {
  const { id, name, className } = props;
  const [viewerOpen, setViewerOpen] = useState<boolean>(false);

  const file = useAttachmentFile(id, name);

  return (
    <>
      <Button type="button" variant="outline" size="sm" className={className} onClick={() => setViewerOpen(true)}>
        <EyeIcon />
        Podgląd
      </Button>
      <MediaViewer file={file} open={viewerOpen} onOpenChange={setViewerOpen} />
    </>
  );
}
